function formatDrivingDistance(t){return t?(Math.floor(10*t)/10).toFixed(1):null}export default formatDrivingDistance;